<script lang="ts">
  import type { LeaderboardSkillsDetailsSkillItem, SkillCategory, SkillCategorySummary } from '$lib/api/types';
  import CategorySkillList from './CategorySkillList.svelte';
  import SkillDetailModal from './SkillDetailModal.svelte';
  interface Props {
    classId: number;
    classEndDate: string;
    classStartDate: string;
    categories: SkillCategory[];
    skills: LeaderboardSkillsDetailsSkillItem[];
    badgeProgressItems: SkillCategorySummary[];
  }

  let { classId, classEndDate, classStartDate, categories, skills, badgeProgressItems }: Props = $props();
  let viewingSkill: LeaderboardSkillsDetailsSkillItem | null = $state(null);
</script>

<div class="category-grid">
  {#each categories as category (category.id)}
    <CategorySkillList
      {classId}
      leaderboardDetails={skills.filter(x => x.skillCategoryId === category.id)}
      {category}
      onskillclicked={skill => {
        viewingSkill = skill;
      }}
    />
  {/each}
</div>

{#if viewingSkill !== null}
  <SkillDetailModal
    {classEndDate}
    {classStartDate}
    bind:viewingSkill
    {classId}
    category={categories.find(x => x.id === viewingSkill!.skillCategoryId)!}
    badgeProgress={badgeProgressItems.find(x => x.skillCategoryId === viewingSkill!.skillCategoryId)}
    possibleSkillCount={skills.filter(x => x.skillCategoryId === viewingSkill!.skillCategoryId).length}
  />
{/if}

<style>
  .category-grid {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
</style>
